import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import react from 'react';
import axios from 'axios';
import {host} from '../../function/api'

const initialState = {
    loading: false,
    success: false,
    status: false,
    Rahpardaznetstatus: false,
    message: '',
    items: [],
    exhibitions: [],
    exhibitionRequestList: [],
    exhibitionRequestData: [],
    removeItem: false,
    errorArchives: '',
    errorNumber: '',
    errorType: '',
    errorNationalCode: '',
}

export const store = createAsyncThunk(
    'exhibitionRequestStore',
    async(data, thunkAPI) => {
        try {
            const response = await axios({
            method: 'POST',
            url: `${host}exhibition/request`,
            data: data,
            headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const index = createAsyncThunk(
    'exhibitionRequestIndex',
    async(thunkAPI) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${host}exhibition/request`,
                headers:{
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const search = createAsyncThunk(
    'exhibitionRequestSearch',
    async(data, thunkAPI) => {
        try {
            const response = await axios({
            method: 'POST',
            url: `${host}exhibition/request/search`,
            data: data,
            headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const documentIndex = createAsyncThunk(
    'document/index',
    async(token, thunkAPI) => {
        try {
            const response = await axios({ 
                method: 'GET',
                url: `${host}document`,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,     
                }
            })

            return response.data;
            
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)



export const EditRequest = createAsyncThunk(
    'exhibitionRequestEdit',
    async(data, thunkAPI) => {
        try {
            const response = await axios({
            method: 'POST',
            url: `${host}exhibition/request/data`,
            data: data,
            headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)
export const searchByRequest = createAsyncThunk(
    'searchByRequest',
    async(data, thunkAPI) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}document/item/search`,
                data: data,
                headers: {
                        'Accept': 'application/json',
                        'xsrfHeaderName': "X-XSRF-TOKEN",
                        'withCredentials': true,
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }    
                })
                
            return await response.data;
            
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)



export const ExhibitionList = createAsyncThunk(
    'exhibitionRequestLists',
    async(data, thunkAPI) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${host}exhibition/list`,
                headers: {
                        'Accept': 'application/json',
                        'xsrfHeaderName': "X-XSRF-TOKEN",
                        'withCredentials': true,
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }    
                })
                
            return await response.data;
            
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const remove = createAsyncThunk(
    'exhibitionRequestRemove',
    async(data, thunkAPI) => {
        try {
            const response = await axios({
            method: 'DELETE',
            url: `${host}exhibition-request/${data.id}`,
            data: data,
            headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const emptyDataRequest = createAsyncThunk(
    'emptyDataRequest',
    async(data, thunkAPI) => {
        try {
            return;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

const ExhibitionRequestSlice = createSlice({
    name: 'ExhibitionRequest',
    initialState,
    reducers: {

    },
    extraReducers: {
        [documentIndex.fulfilled]: (state, action) => {
            
            state.loading = false
            state.documents = action.payload.data
        },
        [documentIndex.pending]: (state) => {
            state.loading = true
        },
        [documentIndex.rejected]: (state, {payload}) => {
            state.loading = false;
            state.success = false
            if(payload.response.data.error){
                state.error = payload.response.data.error
            } else if (payload.response.data.message) {
                state.message = payload.response.data.message
            }
        },
        [searchByRequest.fulfilled]: (state, action) => {

            state.loading = false
            state.success = true
            state.status = true
            state.documents = action.payload.data
        },
        [searchByRequest.pending]: (state) => {
            state.loading = true
            state.success = false
            state.status = false
        },
        [searchByRequest.rejected]: (state, {payload}) => {
            state.loading = false;
            state.success = false
            state.status = false
            if(payload.response.data.error){
                state.errorNumber = payload.response.data.number
                state.errorTypeNumber = payload.response.data.numberType
            } else if (payload.response.data.message) {
                state.message = payload.response.data.message
            }
        },
        
        [emptyDataRequest.fulfilled]: (state, action) => {
            state.loading = false
            state.exhibitions = []
        },
        [emptyDataRequest.pending]: (state) => {
            state.loading = false
            state.exhibitions = []
        },
        [emptyDataRequest.rejected]: (state, {payload}) => {
            state.loading = false;
            state.exhibitions = [];
        },

        [ExhibitionList.fulfilled]: (state, action) => {

            state.loading = false
            state.exhibitions = action.payload.data
        },
        [ExhibitionList.pending]: (state) => {
            state.loading = true
            state.exhibitions = []
        },
        [ExhibitionList.rejected]: (state, {payload}) => {
            state.loading = false;
            state.exhibitions = [];
        },
        [store.fulfilled]: (state,{ payload }) => {
            state.loading = false;
            state.success = true;
            state.message = payload.message;
        },
        [store.pending]: (state) => {
            state.loading= true;
        },
        [store.rejected]: (state, { payload }) => {
            state.loading = false;
            if(payload.response.data.error) {
                state.errorName = payload.response.data.error.name
                state.errorManager = payload.response.data.error.manager
                state.errorCode = payload.response.data.error.code
                state.errorPhone = payload.response.data.error.phone
                state.errorAddress = payload.response.data.error.address
            }
        },
        [remove.fulfilled]: (state, action) => {
            state.loading = false;
            state.success = true;
            state.exhibitionRequestList = action.payload.data
        },
        [remove.pending]: (state) => {
            state.loading = true;
            state.exhibitionRequestList = [];
        },
        [remove.rejected]: (state, { payload }) => {
            state.loading = false;
            state.success = false;
            if(payload.response.data.error){
                state.error = payload.response.data.error
            } else if (payload.response.data.message) {
                state.message = payload.response.data.message
            }
        },
        [search.fulfilled]: (state, action) => {
            state.loading = false;
            state.success = true;
            state.status = true;
            state.message = action.payload.message; 
            state.exhibitionRequestData = action.payload.data;
        },
        [search.pending]: (state) => {
            state.loading = true;
            state.success = false;
            state.status = false;
            state.exhibitionRequestData = [];
            state.message = ""
        },
        [search.rejected]: (state, { payload }) => {
            state.loading = false;
            state.success = false;
            state.status = false;
            state.exhibitionRequestData = [];
            state.message = payload.response.data.message
        },

        [EditRequest.fulfilled]: (state, action) => {
            state.loading = false;
            state.success = true;
            state.Rahpardaznetstatus = true;
            state.message = action.payload.message; 
            state.exhibitionRequestData = action.payload.data;
        },
        [EditRequest.pending]: (state) => {
            state.loading = true;
            state.success = false;
            state.Rahpardaznetstatus = false;
            state.exhibitionRequestData = [];
            state.message = ""
        },
        [EditRequest.rejected]: (state, { payload }) => {
            state.loading = false;
            state.success = false;
            state.Rahpardaznetstatus = false;
            state.exhibitionRequestData = [];
            // console.log(payload.response.data.error.nationalCode)
            state.message = payload.response.data.message
        },
        [remove.fulfilled]: (state, action) => {
            state.loading = false;
            state.success = true;
            state.removeItem = true
            
        },
        [remove.pending]: (state) => {
            state.loading = true;
            state.exhibitionRequestList = [];
        },
        [remove.rejected]: (state, { payload }) => {
            state.loading = false;
            state.success = false;
            if(payload.response.data.error){
                state.error = payload.response.data.error
            }
            if (payload.response.data.message) {
                state.message = payload.response.data.message
            }
        }
    }
})

export const {} = ExhibitionRequestSlice.actions;
export default ExhibitionRequestSlice.reducer;